import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { StatementLinks } from './statement-links.model';
import { Statement } from './statement.model';

export const STATEMENT_INFO_SCHEMA = Object.freeze({
  LINKS: StatementLinks,
  STATEMENT: Statement,
});
const RECORD = generateSchema(STATEMENT_INFO_SCHEMA);
const KEYS: any = generateKeys(STATEMENT_INFO_SCHEMA);

export class StatementInfo extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    return setInModel(this, [
      {
        key: KEYS.LINKS,
        value: new StatementLinks(this.links),
      },
      {
        key: KEYS.STATEMENT,
        value: new Statement(this.statement),
      },
    ]) as StatementInfo;
  }

  get links(): StatementLinks {
    return this.get(KEYS.LINKS);
  }

  get statement(): Statement {
    return this.get(KEYS.STATEMENT);
  }
}
